import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-light py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="page-title">We're here to protect what matters most.</h1>
            <p className="text-lg text-gray-700 leading-relaxed">
              Here Come Protection.com was built on trust and personal service. We know insurance 
              isn't one-size-fits-all, so we take the time to understand your needs and deliver 
              solutions that give you confidence and clarity.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-blue mb-6">Our Story</h2>
              <p className="text-gray-600 mb-4">
                Founded with a simple mission: make insurance accessible, understandable, and 
                tailored to real people's lives. We're not just another insurance agency – 
                we're your neighbors, committed to protecting your family and future.
              </p>
              <p className="text-gray-600 mb-6">
                As an independent agency, we work with multiple carriers to find you the best 
                coverage at the best price. No corporate agenda, no pressure tactics – just 
                honest advice from licensed professionals who care.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact" className="btn-primary">
                  Let's Talk Protection
                </Link>
                <Link to="/quote" className="btn-secondary">
                  Request a Quote
                </Link>
              </div>
            </div>
            <div className="bg-gradient-to-br from-primary-blue to-deep-navy p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-6" style={{color: '#01325B'}}>Licensed & Trusted</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="text-accent-orange text-2xl">✓</div>
                  <span style={{color: '#01325B'}}>Fully licensed insurance professionals</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="text-accent-orange text-2xl">✓</div>
                  <span style={{color: '#01325B'}}>Years of experience serving Texas families</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="text-accent-orange text-2xl">✓</div>
                  <span style={{color: '#01325B'}}>Independent agency with multiple carrier options</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="text-accent-orange text-2xl">✓</div>
                  <span style={{color: '#01325B'}}>Personalized service and ongoing support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="section-light py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="page-title">Our Values</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              These principles guide everything we do for our clients
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-accent-orange text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl">
                🤝
              </div>
              <h3 className="text-xl font-bold text-primary-blue mb-3">Trust</h3>
              <p className="text-gray-600">
                We build lasting relationships based on honesty, transparency, and reliability.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-accent-orange text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl">
                🎯
              </div>
              <h3 className="text-xl font-bold text-primary-blue mb-3">Expertise</h3>
              <p className="text-gray-600">
                Our licensed professionals stay current with industry changes to serve you better.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-accent-orange text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl">
                💙
              </div>
              <h3 className="text-xl font-bold text-primary-blue mb-3">Care</h3>
              <p className="text-gray-600">
                We treat every client like family, providing personalized attention and support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="section-dark py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Ready to Experience the Difference?</h2>
          <p className="text-xl text-gray-300 mb-8">
            Let us show you why personal service still matters in insurance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://calendly.com/g-garza-insure/herecomeprotection" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary text-lg px-8 py-4"
            >
              Schedule a Call
            </a>
            <Link to="/quote" className="btn-secondary text-lg px-8 py-4 text-white border-white hover:bg-white hover:text-deep-navy">
              Get Your Quote
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;